import { useEffect } from "react";
import { triggerShowEcoLabel } from "../../../../common-deprecated/utils/triggerShowEcoLabel";
import { triggerShowSafetyLabel } from "../../../../common-deprecated/utils/triggerShowSafetyLabel";

export const useEcoTable = (): void => {
    useEffect(() => {
        triggerShowEcoLabel();
        triggerShowSafetyLabel();
    }, []);
};
